import { useTranslation } from "react-i18next";
import { Building2, FileSpreadsheet, Download, PackagePlus, PackageMinus, ArrowLeftRight, ClipboardCheck } from "lucide-react";

// أزرار الإجراءات الملوّنة أعلى صفحة المخازن — بنفس فلسفة التطبيق المرجعي.
const ACTIONS = [
  { key: "add_warehouse", icon: Building2, hue: "from-indigo-500 to-indigo-600" },
  { key: "import", icon: FileSpreadsheet, hue: "from-blue-500 to-blue-600" },
  { key: "export", icon: Download, hue: "from-emerald-600 to-emerald-700" },
  { key: "receive", icon: PackagePlus, hue: "from-green-500 to-green-600" },
  { key: "issue", icon: PackageMinus, hue: "from-orange-500 to-orange-600" },
  { key: "transfer", icon: ArrowLeftRight, hue: "from-violet-500 to-violet-600" },
  { key: "count", icon: ClipboardCheck, hue: "from-teal-500 to-cyan-600" },
  { key: "transfers_log", icon: ArrowLeftRight, hue: "from-slate-700 to-slate-800" },
];

export const WhActions = ({ onAction, disabled }) => {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-4 lg:grid-cols-8" data-testid="wh-actions">
      {ACTIONS.map(({ key, icon: Icon, hue }) => (
        <button key={key} type="button" data-testid={`wh-act-${key}`} disabled={disabled}
                onClick={() => onAction(key)}
                className={`flex items-center justify-center gap-2 rounded-2xl px-3 py-4 text-xs font-bold text-white
                  bg-gradient-to-br ${hue} shadow-neu transition hover:scale-105 disabled:opacity-40`}>
          <Icon className="h-4 w-4" /> <span>{t(`warehouse.actions.${key}`)}</span>
        </button>
      ))}
    </div>
  );
};
